customElements.get("ebt-switch") || customElements.define("ebt-switch", class extends ModalOpener {
    constructor() {
        super();
        this.cart = document.querySelector("cart-drawer");
        this.collectionNav = document.querySelector("collection-progress-nav");
        this.opener = this.querySelector('input[type="checkbox"]');
        this.dataset.cartAttributeOnLoad === "true" && (this.opener.checked = true);
        this.opener.addEventListener("click", this.handleCheckboxClick.bind(this));
        this.opener.addEventListener("change", this.handleCheckboxChange.bind(this));
    }

    // Add missing showModal method (not inherited from ModalOpener in this theme)
    showModal() {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(this.opener);
    }

    handleCheckboxClick(event) {
        if (event.currentTarget.checked) {
            event.preventDefault();
            this.showModal();
        }
    }

    handleCheckboxChange(event) {
        this.toggleEbtDiscount(event.currentTarget.checked);
    }

    async toggleEbtDiscount(enabled) {
        const sections = this.getSectionsToRender();
        const body = { attributes: { foodlink_ebt_enabled: enabled.toString() } };

        if (sections.length > 5) {
            // Too many sections for a single render — update attribute and reload
            await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });
            location.reload();
            return;
        }

        body.sections = sections.map(section => section.section);
        body.sections_url = `${window.location.pathname}${window.location.search}`;

        const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        });
        const parsedState = await response.json();
        this.renderSections(sections, parsedState);
        this.syncAllSwitches(enabled);
        this.collectionNav?.initialize();
    }

    // Sync all EBT switches to the same state (handles hidden drawers, etc.)
    syncAllSwitches(enabled) {
        // Use setTimeout to ensure DOM has settled after section rendering
        setTimeout(() => {
            document.querySelectorAll('ebt-switch').forEach(switchEl => {
                const checkbox = switchEl.querySelector('input[type="checkbox"]');
                if (checkbox) {
                    checkbox.checked = enabled;
                }
            });
        }, 100);
    }

    // Inline helper - no global.js modification needed
    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    getSectionOuterHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).outerHTML;
    }

    // Inline rendering - no global.js modification needed
    renderSections(sectionsToRender, parsedState) {
        sectionsToRender.forEach(section => {
            const sectionElement = document.getElementById(section.id);
            if (sectionElement?.parentElement?.classList.contains("drawer")) {
                if ("items" in parsedState) {
                    parsedState.items.length > 0
                        ? sectionElement.parentElement.classList.remove("is-empty")
                        : sectionElement.parentElement.classList.add("is-empty");
                }
                if (this.cart) {
                    setTimeout(() => {
                        document.querySelector("#CartDrawer-Overlay")?.addEventListener("click", this.cart.close.bind(this.cart));
                    });
                }
            }
            let elementToReplace = sectionElement?.querySelector(section.selector) || sectionElement;
            if (elementToReplace && parsedState.sections[section.section]) {
                // For ebt-switch, replace the whole element so custom element re-initializes
                if (section.selector === ".ebt-switch") {
                    const newHTML = this.getSectionOuterHTML(parsedState.sections[section.section], section.selector);
                    elementToReplace.outerHTML = newHTML;
                } else {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
            }
        });
    }

    // Extract section ID from the nearest .shopify-section wrapper
    sectionIdFrom(element) {
        return element?.closest('.shopify-section')?.id.replace('shopify-section-', '');
    }

    getSectionsToRender() {
        const sections = [{
            id: "CartDrawer",
            section: "cart-drawer",
            selector: "#CartDrawer"
        }];

        // Header section (EBT switch only — ID varies per store)
        const headerWrapper = document.querySelector('[id^="shopify-section-"][id$="__header"]');
        if (headerWrapper) {
            sections.push({
                id: headerWrapper.id,
                section: headerWrapper.id.replace('shopify-section-', ''),
                selector: ".ebt-switch"
            });
        }

        // Cart page footer
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter) {
            sections.push({
                id: "main-cart-footer",
                section: this.sectionIdFrom(cartFooter),
                selector: ".ebt-switch"
            });
        }

        // Collection product grid
        const productGrid = document.getElementById("ProductGridContainer");
        if (productGrid) {
            sections.push({
                id: "ProductGridContainer",
                section: this.sectionIdFrom(productGrid),
                selector: "#ProductGridContainer"
            });
        }

        // Main product page
        const mainProduct = document.querySelector('[id^="MainProduct-"]');
        if (mainProduct) {
            const sectionId = this.sectionIdFrom(mainProduct);
            sections.push({
                id: mainProduct.id,
                section: sectionId,
                selector: `#price-${sectionId}`
            });
        }

        // Related products (product page)
        const relatedProducts = document.querySelector('product-recommendations');
        if (relatedProducts) {
            const wrapper = relatedProducts.closest('.shopify-section');
            if (wrapper) {
                sections.push({
                    id: wrapper.id,
                    section: wrapper.id.replace('shopify-section-', ''),
                    selector: ".shopify-section"
                });
            }
        }

        // Any remaining sections with product cards (featured-collection, collage, etc.)
        const trackedSectionIds = new Set(sections.map(s => s.section));
        document.querySelectorAll('#MainContent .shopify-section .product-card-wrapper').forEach(card => {
            const wrapper = card.closest('.shopify-section');
            if (!wrapper) return;
            const sectionId = wrapper.id.replace('shopify-section-', '');
            if (trackedSectionIds.has(sectionId)) return;
            trackedSectionIds.add(sectionId);
            sections.push({
                id: wrapper.id,
                section: sectionId,
                selector: ".shopify-section"
            });
        });

        return sections;
    }

});
